import { currencyColumn, dateColumn, numberColumn, primaryRelationshipColumn, relationshipColumn, textColumn } from "@api/schema/columnHelpers";
import { objectDefinition } from "@api/schema/supportedObjects";
import RapidReinvestmentSection from "./RapidReinvestmentSection";
import { forwardRef } from "react";

const relationshipType = 'default';
const {pluralName, color, endpoint} = objectDefinition(relationshipType);
const columns = [
    textColumn({column: 'name', label: 'Name', required: true}),
    textColumn({column: 'description', label: 'Description'}),
    dateColumn({column: 'received_date', required: true}),
    currencyColumn({required: true}),
];


const PublicInvestments = forwardRef(function PublicInvestments(props, ref) {
    return (
        <RapidReinvestmentSection
            type={relationshipType}
            columns={columns}
            {...props}
            ref={ref}
        />
    )
});

export {PublicInvestments};
